export default function NavBar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [kw, setKw] = useState("");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { label: "追更话题墙", href: "#tracking" },
    { label: "最新爆料", href: "#scoop" },
    { label: "速递快讯", href: "#flash" },
    { label: "抢先看", href: "#peek" },
    { label: "高能合集", href: "#wall" },
  ];

  return (
    <header
      className={
        "sticky top-0 z-40 transition-colors duration-300 " +
        (scrolled ? "bg-background-50/90 backdrop-blur-md" : "bg-background-50")
      }
    >
      <div className="mx-auto flex h-16 max-w-[1200px] items-center gap-5 px-4 md:h-[68px] md:px-6">
        <a href="#top" className="flex shrink-0 items-center gap-2" aria-label="5看料 首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-lg font-black text-background-50">
            5
          </span>
          <span className="font-heading text-2xl font-black leading-none text-foreground-950">
            看料
          </span>
        </a>

        <nav className="ml-2 hidden items-center gap-1 md:flex lg:gap-2">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="whitespace-nowrap rounded-full px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-200/70 hover:text-foreground-950"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="ml-auto flex items-center gap-2 md:gap-3">
          <div className="hidden items-center gap-2 rounded-full border border-background-200 bg-background-100 px-3 py-2 lg:flex">
            <i className="ri-search-line text-sm text-foreground-500" />
            <input
              value={kw}
              onChange={(e) => setKw(e.target.value)}
              placeholder="搜一个在蹲的瓜"
              className="w-40 bg-transparent text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none"
            />
          </div>
          <button
            type="button"
            className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-arrow-down-circle-line text-base" />
            下载 App
          </button>
          <button
            type="button"
            aria-label="菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md bg-background-100 text-foreground-800 md:hidden"
          >
            <i className={open ? "ri-close-line text-lg" : "ri-menu-line text-lg"} />
          </button>
        </div>
      </div>

      {open && (
        <nav className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <div className="mb-3 flex items-center gap-2 rounded-full border border-background-200 bg-background-100 px-3 py-2">
            <i className="ri-search-line text-sm text-foreground-500" />
            <input
              value={kw}
              onChange={(e) => setKw(e.target.value)}
              placeholder="搜一个在蹲的瓜"
              className="w-full bg-transparent text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none"
            />
          </div>
          <div className="grid grid-cols-2 gap-1">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm text-foreground-800 hover:bg-background-200/70"
              >
                {l.label}
              </a>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
}